import { useState } from "react";

import GalleryImgs from "./GalleryImgs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const GalleryHero = () => {
	const genreTypes = {
		General108: "صور عامة",
		AlAqsa021: "المسجد الأقصى",
		Car011: "السيارات",
		Quds008: "القدس",
		Nature030: "أرض الله",
		Portrait010: "الصور الشخصية",
		ChildrenOfAlAqsa028: "أطفال الأقصى",
	};
	const [imageGenre, setImageGenre] = useState("General108");
	const [rowsPerColumn, setRowsPerColumn] = useState(4);

	const [maxRowsPerColumn, setMaxRowsPerColumn] = useState(
		imageGenre === "Quds008" ? Math.floor(parseInt(imageGenre.slice(-3)) / 3) : Math.ceil(parseInt(imageGenre.slice(-3)) / 3)
	);
	const imgGenreForwards = () => {
		setRowsPerColumn(3);
		const genreKeys = Object.keys(genreTypes);
		const currentGenreIndex = genreKeys.indexOf(imageGenre);
		if (currentGenreIndex !== -1 && currentGenreIndex < genreKeys.length - 1) {
			setImageGenre(genreKeys[currentGenreIndex + 1]);
		} else {
			setImageGenre("General108");
		}
	};

	const imgGenreBackwards = () => {
		setRowsPerColumn(3);
		const genreKeys = Object.keys(genreTypes);
		const currentGenreIndex = genreKeys.indexOf(imageGenre);
		if (currentGenreIndex !== -1 && currentGenreIndex !== 0) {
			setImageGenre(genreKeys[currentGenreIndex - 1]);
		} else {
			setImageGenre("ChildrenOfAlAqsa028");
		}
	};

	return (
		<>
			<section className="text-center my-8">
				<h1 className="text-[3.5rem] font-diwan my-8 lg:text-[8rem]">معرض الصور</h1>
				<div className="flex flex-row place-content-center">
					<button onClick={imgGenreForwards}>
						<FontAwesomeIcon
							className="mx-8 h-8 lg:h-16"
							icon={faArrowRight}
							style={{
								color: "#000000",
							}}
						/>
					</button>
					<h2 id="gallery-type" className="border-4 border-black rounded-lg px-3 py-1 text-[2rem] lg:px-6 lg:py-2 lg:text-[3.5rem]">
						{Object.values(genreTypes[imageGenre])}
					</h2>
					<button onClick={imgGenreBackwards}>
						<FontAwesomeIcon
							className="mx-8 h-8 lg:h-16"
							icon={faArrowLeft}
							style={{
								color: "#000000",
							}}
						/>
					</button>
				</div>
			</section>
			<GalleryImgs
				imageGenre={imageGenre}
				rowsPerColumn={rowsPerColumn}
				setRowsPerColumn={setRowsPerColumn}
				maxRowsPerColumn={maxRowsPerColumn}
				setMaxRowsPerColumn={setMaxRowsPerColumn}
			/>
		</>
	);
};

export default GalleryHero;
